module.exports = __webpack_public_path__ + "img/dropdown-arrow.6f7fa553.svg";